import { IAvailableStore } from 'types';

interface StoreLocatorAction {
    step: string;
    interaction: string;
    location?: string;
    searchResults?: number;
    searchPosition?: number;
}

interface StoreInfo {
    id: string;
    name: string;
    city: string;
    country: string;
    address: string;
    postalCode: string;
    preferredStore: boolean;
}

interface StoreLocatorEvent {
    event: string;
    storeLocator: {
        action: StoreLocatorAction;
        store?: StoreInfo;
    };
}

export const dataLayerStoreEvent = (
    store: IAvailableStore,
    searchPosition: number,
    interaction: string
) => {
    const { id, storeName, address, city, postalCode } = store;

    pushToDataLayer('storeSearchResults', {
        action: {
            step: 'store locator results',
            interaction,
            searchPosition,
        },
        store: {
            id,
            name: storeName,
            address: `${address}, ${city}`,
            country: 'NL',
            postalCode,
            city,
            preferredStore: false,
        },
    });
};

export function stripAndTruncate(text: string) {
    const strippedText = text
        .replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '') // Strip HTML
        .replace('\n', ' ')
        .replace(/[ ]{2,}/g, ' '); // Remove extra spaces

    if (strippedText.length >= 100) {
        return strippedText.slice(0, 100).concat('...');
    }

    return strippedText;
}

export function pushToDataLayer(
    eventName: string,
    data: Partial<StoreLocatorEvent['storeLocator']>
) {
    if (typeof window === 'undefined') return;

    window.dataLayer = window.dataLayer || [];

    const eventPayload: StoreLocatorEvent = {
        event: eventName,
        storeLocator: data as StoreLocatorEvent['storeLocator'],
    };

    window.dataLayer.push(eventPayload);
}
